import { CheckIcon, LinkIcon, UploadIcon, XIcon } from '@primer/octicons-react';
import { Box, Link, TextInput } from '@primer/react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { foMonAnChiTietApi } from '../../../../api/foMonAnChiTietApi';
import { uploadApi } from '../../../../api/uploadApi';
import { appInfo } from '../../../../AppInfo';
import { AnimationPopup } from '../../../../components/modal';
import { PopUpForm, PopUpFormActions } from '../../../../components/pop-up-form/PopUpForm';
import Button from '../../../../components/ui/button';
import DataTable from '../../../../components/ui/data-table';
import { useCommonContext } from '../../../../contexts/common';
import { NotifyHelper } from '../../../../helpers/toast';
import { RootState } from '../../../../state/reducers';
import styles from './MonAnImport.module.css';
interface IMonAnImportModalProps {
    onClose: () => void;
    animationOf: string;
}
const MonAnImport = (props: IMonAnImportModalProps) => {
    const { translate } = useCommonContext();
    const { animationOf, onClose } = props;
    const { dm_truong_selected_id, nam_hoc } = useSelector((x: RootState) => x.common);
    const [uploadedFileName, setUploadedFileName] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const componentDidMount = useRef<boolean>(false);
    const [dataSouce, setDataSouce] = useState<any[]>([]);
    const [dataSouceValidated, setDataSouceValidated] = useState<any[]>([]);

    const notValidCount = useMemo<number>(() => {
        return dataSouceValidated.filter((x) => x["Thông tin lỗi"] !== "" && x["Thông tin lỗi"] !== null).length;
    }, [dataSouceValidated]);
    const handleSelectFile = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute(
            'accept',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
        );
        input.click();
        input.onchange = async () => {
            var file = input && input.files ? input.files[0] : null;
            if (file) {
                const res = await uploadApi.uploadExcel(file)
                if (res.is_success) {
                    setUploadedFileName(res.data.fileNameId)
                } else {
                    NotifyHelper.Error(res.message ?? "Error")
                }
            }
        };
        input.remove();
    };
    useEffect(() => {
        componentDidMount.current = true;
        if (uploadedFileName !== "") {
            setIsLoading(true);
            handleReadUploadedFile();
            setIsLoading(false);
        }
    }, [uploadedFileName]);

    const handleReadUploadedFile = async () => {
        // setIsLoading(true);
        // const res = await uploadApi.readExcel({
        //     fileName: uploadedFileName,
        //     sheetIndex: 0,
        // });

        // if (!componentDidMount.current) return;
        // setIsLoading(false);

        // if (res.is_success) {
        //     console.log(res.data)
        //     setDataSouce(res.data);
        // }
        await handleValidateImportFile();
    };
    const handleValidateImportFile = async () => {
        setIsLoading(true);
        const datasend = {
            fileName: uploadedFileName,
            sheetIndex: 0
        }
        const res = await foMonAnChiTietApi.validate_import(datasend);
        if (!componentDidMount.current) return;
        if (res.is_success) {
            setDataSouceValidated(res.data);
        }
        setIsLoading(false);
    };
    const hanldeImport = async () => {
        setIsLoading(true);
        const datasend = {
            fileName: uploadedFileName,
            sheetIndex: 0
        }
        const res = await foMonAnChiTietApi.import(datasend);
        if (!componentDidMount.current) return;
        setIsLoading(false);
        if (res.is_success) {
            NotifyHelper.Success(res.message ?? "Success!");
        } else {
            NotifyHelper.Error(res.message ?? "Error")
        }
        onClose();
    };
    const columns = useMemo(() => {
        if (!dataSouceValidated || dataSouceValidated.length === 0) return [];
        const keys = Object.keys(dataSouceValidated[0]).filter((key) => key !== "0" && key !== "ID");

        return [
            ...keys.map((key) => ({
                dataField: key,
                caption: key,
            })),
        ];
    }, [dataSouceValidated]);
    return (
        <>
            <AnimationPopup
                animationOf={animationOf}
                width={"80%"}
                title='Import món ăn'

                onClose={onClose}
            >
                <Box sx={{
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "85vh",
                }}>                    <Box sx={{
                    display: "flex"
                }}>
                        <Box>

                        </Box>
                        <Box>
                            <Box>
                                <Button leadingVisual={UploadIcon} text='Upload file' onClick={handleSelectFile}
                                    size='medium'
                                />
                            </Box>
                            {uploadedFileName &&
                                <TextInput sx={{ ml: 2, width: 400 }} value={uploadedFileName} readOnly />
                            }
                            <Box className={styles.action_item} sx={{ flex: 1 }}>
                            </Box>
                            <Box className={styles.action_item}>
                                <Link href={`${appInfo.baseApiURL.replace('/api', '')}/TEMPLATE/IMPORT_MONAN.xlsx`} target='_blank'>
                                    <Button sx={{ color: 'blue' }} text={`${translate(`Tải mẫu import món ăn tại đây`)}`}
                                        variant='invisible'
                                        leadingVisual={LinkIcon}
                                    />
                                </Link>

                            </Box>
                        </Box>
                    </Box>
                    <Box>
                        <DataTable
                            data={dataSouceValidated}
                            isLoading={isLoading}
                            paging={{ enable: true }}
                            columns={columns}
                        />
                    </Box>

                    <PopUpFormActions>
                        <Button leadingVisual={XIcon} text='Base.Label.Close' onClick={onClose} />
                        <Button
                            leadingVisual={CheckIcon}
                            variant='primary'
                            isLoading={isLoading}
                            text={'ThoiKhoaBieuImport.Label.Save'}
                            disabled={notValidCount > 0}
                            onClick={hanldeImport}
                        ></Button>
                    </PopUpFormActions>
                </Box>
            </AnimationPopup>
        </>
    );
};

export default MonAnImport;
